import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Popup } from 'src/components/Popup';
import FormRow from 'src/components/Form/FormRow';
import s from 'src/components/CapActionDeletePopup/CapActionDeletePopup.styles';

export const CapActionDeletePopup = ({ onClose, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Popup
      level={2}
      onClose={onClose}
      title={<s.Title>{t('DELETE_CONFIRM_TITLE')}</s.Title>}
      withOverflow
      >
      <FormRow inline spaced>
        <s.SubmitButton
          onClick={async e => {
            e.preventDefault();

            await onSubmit();
            onClose();
          }}
          orange
          sm
          solid
        >
          {t('YES')}
        </s.SubmitButton>
        <s.LinkButton ghost onClick={onClose} red sm type="button">
          {t('NO')}
        </s.LinkButton>
      </FormRow>
    </Popup>
  );
};

CapActionDeletePopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

CapActionDeletePopup.defaultProps = {};
